import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ContratosTemplate from "../../components/templates/clientes/ContratosTemplate";

const Contratos = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		if (!id) {
			navigate("/dashboard");
		}
	}, [id, navigate]);

	if (!id) {
		return null;
	}

	return (
		<div>
			<ContratosTemplate clientId={id} />
		</div>
	);
};

export default Contratos;